<template>
    <div class="contact d-flex align-items-center justify-content-center">
        <div class="row d-flex flex-row contact-us-div">
            <div class="col-lg-6 col-12 company-logo">
                <img src="logo.webp" />
            </div>
            <div class="col-lg-6 col-12 contact-info-div text-white">
                <div class="row">
                    <div class="col-lg-12 col-sm-6 col-12">
                        <h2>Contact Us</h2>
                        <h4 @click="showForm = true"><a>
                                <Mail />&nbsp;&nbsp;cacoates@sowellprepared.org
                            </a>
                        </h4>
                        <h4 @click="showForm = true"><a>
                                <PhoneCall />&nbsp;&nbsp;+1(214)745-5569
                            </a>
                        </h4>
                        <hr class="d-block d-sm-none d-lg-block">
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                        <h2>Business Hours</h2>
                        <h5>Monday - Friday: 11AM - 3PM CST</h5>
                        <h5>Saturday - Sunday: 6AM - 12PM CST</h5>
                        <hr class="d-block d-sm-none d-lg-block">
                    </div>
                </div>
                <hr class="d-none d-sm-block d-lg-none">
                <a class="router-link-appointment-contact" href="http://booking.sowellprepared.org">Make An
                    Appointment</a>
            </div>
        </div>
    </div>
    <div>
        <div v-if="showForm" class="overlay" @click.self="closeForm(false)">
            <div class="contact-form">
                <div class="row d-flex flex-row">
                    <div class="col-12 d-flex justify-content-end">
                        <button class="exit-btn" @click="closeForm(true)">&times;</button>
                    </div>
                    <div class="col-12 d-flex justify-content-start">
                        <h2>Contact Us</h2>
                    </div>
                </div>
                <form @submit.prevent="submitForm">
                    <div class="form-group">
                        <label for="name">Name</label>
                        <input v-model="form.name" placeholder="Enter Your Name" type="text" id="name" required />
                    </div>

                    <div class="form-group">
                        <label for="phone">Phone Number</label>
                        <input v-model="form.phone" placeholder="Enter Your Phone Number" type="tel" id="phone" required />
                    </div>

                    <div class="form-group">
                        <label for="email">Email</label>
                        <input v-model="form.email" placeholder="Enter Your Email" type="email" id="email" required />
                    </div>

                    <div class="form-group">
                        <label for="message">Message</label>
                        <textarea v-model="form.message" placeholder="Enter Your Message" id="message" rows="5"
                            required></textarea>
                    </div>

                    <button type="submit">Send Message</button>
                </form>
            </div>
        </div>
        <transition name="fade">
            <div v-if="showSuccess" class="success-toast">
                <p>
                    <SquareCheckBig /> Thank you for the message!<br />We’ll get back to you as soon as possible.
                </p>
            </div>
        </transition>
        <transition name="fade">
            <div v-if="showFailure" class="success-toast">
                <p>
                    <MessageSquareX /> The message failed to send.<br />Please try again later.
                </p>
            </div>
        </transition>
    </div>
</template>

<script>
import { Mail } from 'lucide-vue-next';
import { PhoneCall } from 'lucide-vue-next';
import { SquareCheckBig } from 'lucide-vue-next';
import { MessageSquareX } from 'lucide-vue-next';
import { sendContactFormMessage } from "@/api/backend"
export default {
    name: 'ContactView',
    components: {
        Mail,
        PhoneCall,
        SquareCheckBig,
        MessageSquareX
    },
    data() {
        return {
            showForm: false,
            showSuccess: false,
            showFailure: false,
            form: {
                name: "",
                phone: "",
                email: "",
                message: ""
            }
        };
    },
    watch: {
        showForm(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        }
    },
    methods: {
        async submitForm() {
            try {
                const response = await sendContactFormMessage(this.form)
                if (response.status >= 200 && response.status < 300) {
                    this.form = { name: "", phone: "", email: "", message: "" };
                    this.showForm = false;
                    this.showFailure = true;
                    setTimeout(() => {
                        this.showFailure = false;
                    }, 4000);
                }
                this.form = { name: "", phone: "", email: "", message: "" };
                this.showForm = false;
                this.showSuccess = true;
                setTimeout(() => {
                    this.showSuccess = false;
                }, 4000);
            } catch (error) {
                this.form = { name: "", phone: "", email: "", message: "" };
                this.showForm = false;
                this.showFailure = true;
                setTimeout(() => {
                    this.showFailure = false;
                }, 4000);
            }
        },
        closeForm(forceClose) {
            if (window.innerWidth > 576 || forceClose) {
                this.showForm = false;
            }
        }
    }
}
</script>

<style>
hr {
    margin: 1.5rem 0;
    color: white
}

.contact {
    padding: 2.5% 7.5%;
}

.contact-info-div {
    padding: 0 5%;
}

.contact-info-div a {
    color: white;
}

.contact-info-div h2 {
    color: #ffffff;
    font-weight: bold;
    text-align: left;
    font-size: 2.25rem;
    margin: 0.75rem 0;
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
    letter-spacing: 1px;
    padding-top: 1rem;
}

.contact-us-div h5 {
    color: white;
    text-align: left;
    margin-top: 0.25rem;
    letter-spacing: 0.5px;
    font-weight: bolder;
    font-size: 1.55rem;
}

.contact-us-div h4 {
    font-size: 1.65rem;
}

.contact-us-div {
    background: #7c7c7c;
    padding: 20px 20px;
    border-radius: 15px;
    width: 100%;
    box-shadow: rgba(255, 255, 255, 0.2) 0px 5px 15px;
}

.company-logo img {
    width: 97.5%;
    margin-left: 2.5%;
    border-radius: 12.5px
}

.router-link-appointment-contact {
    background: #364248;
    color: white;
    text-decoration: none;
    padding: 0.75rem 1.25rem;
    font-size: 1.6rem;
    border-radius: 7.5px;
    width: 100% !important
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1500;
}

.contact-form {
    background: #fff;
    padding: 2rem;
    border-radius: 10px;
    max-width: 500px;
    width: 100%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    position: relative;
    z-index: 10000
}

/* Form styles */
.contact-form h2 {
    text-align: center;
}

.contact-form .exit-btn,
.contact-form .exit-btn:hover {
    font-size: 1.9rem;
    color: #0056b3;
    background-color: transparent;
    width: 1rem;
    padding: 0;
    position: absolute;
    top: 10px;
    right: 20px;
    border: none;
    cursor: pointer;
}

.contact-form .form-group {
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
}

.contact-form label {
    margin-bottom: 0.5rem;
    font-weight: 600;
}

.contact-form input,
.contact-form textarea {
    padding: 0.75rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 1rem;
}

.contact-form button {
    width: 100%;
    padding: 0.75rem;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
}

.contact-form button:hover {
    background: #0056b3;
}

.success-toast {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: #0056b3;
    color: white;
    padding: 0.75rem 0.75rem;
    padding-bottom: 0.15rem;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    font-size: 1rem;
    text-align: center;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

@media(max-width: 1200px) and (min-width: 992px) {
    .contact-info-div h2 {
        font-size: 1.5rem;
        margin-top: 0.25rem
    }

    .contact-us-div h4 {
        font-size: 1.3rem;
    }

    .contact-us-div h5 {
        font-size: 1.25rem;
    }

    hr {
        margin: 1rem 0;
    }

    .router-link-appointment-contact {
        padding: 0.75rem 1.25rem;
        font-size: 1.45rem;
    }
}

@media(max-width: 992px) and (min-width: 768px) {
    .company-logo img {
        width: 60%;
        margin-left: 20%;
        border-radius: 12.5px
    }

    .contact-info-div h2 {
        font-size: 1.45rem;
    }

    .contact-us-div h4 {
        font-size: 1.1rem;
    }

    .contact-us-div h5 {
        font-size: 0.95rem;
    }

    hr {
        margin: 1.25rem 0;
    }

    .contact-info-div {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .router-link-appointment-contact {
        padding: 0.5rem;
        font-size: 1.25rem;
        border-radius: 5px;
        text-align: center;
    }

    .contact-info-div svg {
        width: 20px;
        height: 20px
    }
}

@media(max-width: 768px) and (min-width: 576px) {
    .company-logo img {
        width: 60%;
        margin-left: 20%;
        border-radius: 12.5px
    }

    .contact-info-div h2 {
        font-size: 1.1rem;
    }

    .contact-us-div h4 {
        font-size: 0.76rem;
    }

    .contact-us-div h5 {
        font-size: 0.675rem;
    }

    hr {
        margin: 1rem 0;
    }

    .contact-info-div {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .router-link-appointment-contact {
        padding: 0.2rem;
        font-size: 1rem;
        border-radius: 3.5px;
        text-align: center;
    }

    .contact-info-div svg {
        width: 17.5px;
        height: 17.5px
    }
}

@media(max-width: 576px) and (min-width: 420px) {
    .company-logo img {
        width: 100%;
        border-radius: 12.5px;
        margin-left: 0%;
    }

    .contact-info-div h2 {
        font-size: 1.3rem;
        margin-top: 0rem;
        text-align: center;
    }

    .contact-us-div h4 {
        font-size: 1.15rem;
        text-align: center;
    }

    .contact-us-div h5 {
        font-size: 1.05rem;
        text-align: center;
    }

    hr {
        margin: 1.25rem 0;
    }

    .contact-info-div {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .router-link-appointment-contact {
        padding: 0.5rem;
        font-size: 1.15rem;
        border-radius: 7.5px;
        text-align: center;
    }

    .contact-info-div svg {
        width: 20px;
        height: 20px
    }

    .contact {
        padding: 7.5% 7.5%;
    }

    .contact-form {
        padding: 1.25rem;
        border-radius: 10px;
        max-width: 400px;
        width: 100%;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    .contact-form .exit-btn,
    .contact-form .exit-btn:hover {
        font-size: 1.9rem;
        width: 1rem;
        padding: 0;
        top: 10px;
        right: 20px;
    }

    .contact-form .form-group {
        margin-bottom: 1rem;
    }

    .contact-form label {
        margin-bottom: 0.5rem;
    }

    .contact-form input,
    .contact-form textarea {
        padding: 0.75rem;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 1rem;
    }

    .contact-form button {
        width: 100%;
        padding: 0.75rem;
        border-radius: 4px;
        font-size: 1rem;
    }

    .success-toast {
        bottom: 20px;
        right: 20px;
        padding: 0.75rem 0.75rem;
        padding-bottom: 0.15rem;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        font-size: 1rem;
    }

    .contact-form:focus-within form {
        height: 375px;
        overflow-y: scroll;
    }

    .contact-form:focus-within {
        bottom: 22.5%;
    }

    .contact-form .exit-btn,
    .contact-form .exit-btn:hover {
        font-size: 2.1rem;
    }
}

@media(max-width: 420px) and (min-width: 360px) {
    .company-logo img {
        width: 100%;
        border-radius: 12.5px;
        margin-left: 0%;
    }

    .contact-info-div h2 {
        font-size: 1.3rem;
        margin-top: 0rem;
        text-align: center;
    }

    .contact-us-div h4 {
        font-size: 1.0125rem;
        text-align: center;
    }

    .contact-us-div h5 {
        font-size: 0.925rem;
        text-align: center;
    }

    .contact {
        padding: 0 3.5%;
    }

    hr {
        margin: 0.75rem 0;
    }

    .contact-info-div {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .router-link-appointment-contact {
        padding: 0.4rem;
        font-size: 1.15rem;
        border-radius: 7.5px;
        text-align: center;
    }

    .contact-info-div svg {
        width: 15.5px;
        height: 15.5px
    }

    .contact {
        padding: 7.5% 7.5%;
    }

    .contact-form {
        padding: 1.25rem;
        border-radius: 10px;
        max-width: 350px;
        width: 100%;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    .contact-form:focus-within form {
        height: 310px;
        overflow-y: scroll;
    }

    .contact-form:focus-within {
        bottom: 20.5%;
    }

    .contact-form .exit-btn,
    .contact-form .exit-btn:hover {
        font-size: 2.15rem;
    }
}

@media(max-width: 360px) {
    .company-logo img {
        width: 100%;
        border-radius: 12.5px;
        margin-left: 0%;
    }

    .contact-info-div h2 {
        font-size: 1.15rem;
        margin-top: 0rem;
        text-align: center;
    }

    .contact-us-div h4 {
        font-size: 0.95rem;
        text-align: center;
    }

    .contact-us-div h5 {
        font-size: 0.85rem;
        text-align: center;
    }

    .contact {
        padding: 0 3.5%;
    }

    hr {
        margin: 0.75rem 0;
    }

    .contact-info-div {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .router-link-appointment-contact {
        padding: 0.3rem;
        font-size: 1rem;
        border-radius: 5px;
        text-align: center;
    }

    .contact-info-div svg {
        width: 13.5px;
        height: 13.5px
    }

    .contact {
        padding: 7.5% 7.5%;
    }

    .contact-form {
        padding: 1.25rem;
        border-radius: 10px;
        max-width: 300px;
        width: 100%;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    .contact-form:focus-within form {
        height: 270px;
        overflow-y: scroll;
    }

    .contact-form:focus-within {
        bottom: 20%;
    }
}
</style>